"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* eslint-disable brace-style, no-unneeded-ternary */
var store = require('./store');
var HumanityCheck = require('./humanity-check');
var helpers = require('./helpers');
var _require = require('./helpers'),
  obfuscatePiiRequest = _require.obfuscatePiiRequest;
var storageKey = '_constructorio_requests';
var requestTTL = 180000; // 3 minutes in milliseconds
var RequestQueue = /*#__PURE__*/function () {
  function RequestQueue(options, eventemitter) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, RequestQueue);
    this.options = options;
    this.eventemitter = eventemitter;
    this.humanity = new HumanityCheck();
    this.requestPending = false;
    this.pageUnloading = false;
    this.sendTrackingEvents = options && options.sendTrackingEvents === true ? true : false; // Defaults to 'false'

    helpers.addEventListener('visibilitychange', function () {
      // Mark if page environment is unloading
      if (document.visibilityState === 'hidden') {
        _this.pageUnloading = true;
      } else if (document.visibilityState === 'visible' && _this.pageUnloading === true) {
        // Send events once page is visible again
        _this.pageUnloading = false;
        if (_this.sendTrackingEvents) {
          _this.send();
        }
      }
    });
    if (this.sendTrackingEvents) {
      this.send();
    }
  }

  // Add request to queue to be dispatched
  (0, _createClass2["default"])(RequestQueue, [{
    key: "queue",
    value: function queue(url) {
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var networkParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      // Consider user "human" if no DOM context is available
      if (this.sendTrackingEvents && (!helpers.canUseDOM() || !this.humanity.isBot())) {
        var queue = RequestQueue.get();

        // PII Detection & Obfuscation
        var obfuscatedUrl = obfuscatePiiRequest(url);
        queue.push({
          url: obfuscatedUrl,
          method: method,
          body: body,
          networkParameters: networkParameters
        });
        RequestQueue.set(queue);
      }
    }

    // Read from queue and send events to server
  }, {
    key: "sendEvents",
    value: function sendEvents() {
      var _this2 = this;
      var fetch = this.options.fetch;
      var queue = RequestQueue.get();
      if (
      // Consider user "human" if no DOM context is available
      (!helpers.canUseDOM() || !this.humanity.isBot()) && !this.requestPending && !this.pageUnloading && queue.length) {
        var request;
        var nextInQueue = queue.shift();
        var _nextInQueue = nextInQueue,
          networkParameters = _nextInQueue.networkParameters;
        var signal;
        var instance = this;
        RequestQueue.set(queue);
        if (networkParameters && typeof AbortController === 'function') {
          var controller = new AbortController();
          signal = controller.signal;
          helpers.applyNetworkTimeout(this.options, networkParameters, controller);
        }

        // Backwards compatibility with versions <= 2.0.0, can be removed in future
        // - Request queue entries used to be strings with 'GET' method assumed
        if (typeof nextInQueue === 'string') {
          nextInQueue = {
            url: nextInQueue,
            method: 'GET'
          };
        }

        // If events older than `requestTTL` exist in queue, clear request queue
        // - Prevents issue where stale items are sent in perpetuity
        // - No request should go unsent for longer than `requestTTL`
        if (nextInQueue.url) {
          // Pull `dt` parameter from URL, indicating origin time of request
          var dtMatch = nextInQueue.url.match(/\?.*_dt=([^&]+)/);
          var requestOriginTime = parseInt(dtMatch && dtMatch[1], 10);
          var now = +new Date();
          if (requestOriginTime && Number.isInteger(requestOriginTime) && now - requestOriginTime > requestTTL) {
            this.sendTrackingEvents = false;
            RequestQueue.remove();
            return;
          }
        }
        if (nextInQueue.method === 'GET') {
          request = fetch(nextInQueue.url, {
            signal: signal
          });
        }
        if (nextInQueue.method === 'POST') {
          request = fetch(nextInQueue.url, {
            method: nextInQueue.method,
            body: JSON.stringify(nextInQueue.body),
            mode: 'cors',
            headers: {
              'Content-Type': 'text/plain'
            },
            signal: signal
          });
        }
        if (request) {
          this.requestPending = true;
          request.then(function (response) {
            // Request was successful, and returned a 2XX status code
            if (response.ok) {
              if (instance.eventemitter) {
                instance.eventemitter.emit('success', {
                  url: nextInQueue.url,
                  method: nextInQueue.method,
                  message: 'ok'
                });
              }
              _this2.requestPending = false;
              _this2.send();
            }

            // Request was successful, but returned a non-2XX status code
            else {
              response.json().then(function (json) {
                if (instance.eventemitter) {
                  instance.eventemitter.emit('error', {
                    url: nextInQueue.url,
                    method: nextInQueue.method,
                    message: json && json.message
                  });
                }
                _this2.requestPending = false;
                _this2.send();
              })["catch"](function (error) {
                if (instance.eventemitter) {
                  instance.eventemitter.emit('error', {
                    url: nextInQueue.url,
                    method: nextInQueue.method,
                    message: error.type
                  });
                }
                _this2.requestPending = false;
                _this2.send();
              });
            }
          })["catch"](function (error) {
            if (instance.eventemitter) {
              instance.eventemitter.emit('error', {
                url: nextInQueue.url,
                method: nextInQueue.method,
                message: error && error.toString && error.toString()
              });
            }
            _this2.requestPending = false;
            _this2.send();
          });
        }
      }
    }

    // Read from queue and send requests to server
  }, {
    key: "send",
    value: function send() {
      if (this.sendTrackingEvents) {
        if (this.options && this.options.trackingSendDelay === 0) {
          this.sendEvents();
        } else {
          // Defer sending of events to give visibilitychange time to register (avoids race condition)
          setTimeout(this.sendEvents.bind(this), this.options && this.options.trackingSendDelay || 250);
        }
      }
    }

    // Return current request queue
  }], [{
    key: "get",
    value: function get() {
      return store.local.get(storageKey) || [];
    }

    // Update current request queue
  }, {
    key: "set",
    value: function set(queue) {
      // If queue length is zero, remove entry entirely
      if (!queue || Array.isArray(queue) && queue.length === 0) {
        RequestQueue.remove();
      } else {
        store.local.set(storageKey, queue);
      }
      var localStorageQueue = RequestQueue.get();

      // Ensure storage queue was set correctly in storage by checking length
      // - Otherwise remove all pending requests as preventative measure
      // - Firefox seeing identical events being transmitted multiple times
      if (Array.isArray(localStorageQueue) && localStorageQueue.length !== queue.length) {
        this.sendTrackingEvents = false;
        RequestQueue.remove();
      }
    }

    // Remove current request queue key
  }, {
    key: "remove",
    value: function remove() {
      store.local.remove(storageKey);
    }
  }]);
  return RequestQueue;
}();
module.exports = RequestQueue;